import React, { useState, useEffect } from "react";
import { Row, Col, Button, Spinner } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import ApiAmusementComplex from "../../../core/api/api.amusementComplex";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import { Link, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import ShowImages from "./ShowImages/ShowImages";
import TextEditor from "../_Components/CkEditor/Index";
import ApiRegion from "../../../core/api/api.region";
import ApiAmusementService from "../../../core/api/api.amusementService";
import SelectComponent from "../_Components/ReactSelectComponent";
import { numberWithDotRegex, tools } from "../../../core/utils/tools";

const CreateEditAmusementComplex = () => {
  const {
    handleSubmit: handleSubmit2,
    control: control2,
    formState: { errors: errors2, isSubmitting },
    getValues: getValues2,
    setValue: setValue2,
  } = useForm({ defaultValues: { id: 0 } });

  let { id } = useParams();
  const [allCityList, setAllCityList] = useState([]);
  const [allAmusementServiceList, setAllAmusementServiceList] = useState([]);
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, // مقدار دلخواه z-index
    }),
    // شما می‌توانید دیگر بخش‌های کامپوننت را نیز استایل کنید
  };
  useEffect(() => {
    (async () => {
      try {
        //  گرفتن شهرها و سرویس‌ها همزمان
        const [cityResponse, services] = await Promise.all([
          ApiRegion.getAllCity(),
          ApiAmusementService.getAllServices(),
        ]);

        setAllCityList(cityResponse || []);
        setAllAmusementServiceList(services || []);

        //  اگر id موجوده، مقدار اولیه ست بشه
        if (id && id !== 0) {
          const response = await ApiAmusementComplex.get(id);
          if (response.succeeded) {
            const data = response.data;

            setValue2("id", data.id);
            setValue2("imageUrl", data.imageUrl);
            setValue2("name", data.name);
            setValue2("nameEn", data.nameEn);
            setValue2("urlName", data.urlName);
            setValue2("metaDescription", data.metaDescription);
            setValue2("metaKeywords", data.metaKeywords);
            setValue2("pageTitle", data.pageTitle);
            setValue2("status", data.status);
            setValue2("description", data.description);
            setValue2("descriptionSummary", data.descriptionSummary);
            setValue2("showInHomePage", data.showInHomePage);
            setValue2("showInAmusementGroupPage", data.showInAmusementGroupPage);
            setValue2("lat", data.lat);
            setValue2("lon", data.lon);
            setValue2("address", data.address);

            //  مقدار اولیه cityList
            setValue2(
              "cityList",
              data.amusementComplexRegions.map((item) => ({
                value: item.region.id,
                label: item.region.id + "-" + item.region.name,
                labelId: item.id,
              })),
            );

            //  مقدار اولیه amusementList فقط بعد از اینکه services آماده شدند
            if (!_.isEmpty(services)) {
              setValue2(
                "amusementList",
                data.amusementServiceAmusementComplexes.map((item) => ({
                  value: item.amusementService.id,
                  label: item.amusementService.id + "-" + item.amusementService.name,
                })),
              );
            }
          }
        } else {
          setValue2("id", 0);
        }
      } catch (error) {
      }
    })();
  }, [id]);

  const onSubmit2 = async (data) => {
    try {
      if (data.cityList?.length > 0) {
        let cityListObj = [];
        let tt = data.cityList?.map((item) => {
          cityListObj.push({
            regionId: item.value, //,amusementComplexId: item.labelId
          });
        });

        data.cityList = cityListObj;
      }
      if (data.amusementList?.length > 0) {
        let amusementListObj = [];
        let tt = data.amusementList?.map((item) => {
          amusementListObj.push(item.value);
        });

        data.amusementList = amusementListObj;
      }

      let response = null;
      if (data.id <= 0) response = await ApiAmusementComplex.create(data);
      else response = await ApiAmusementComplex.update(data.id, data);
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };
  function handleChangeMultiCity(value, selectItem) {
    setValue2("cityList", value);
    let id = [];
    if (!_.isEmpty(getValues2("cityList"))) {
      getValues2("cityList").map((item) => id.push(item.value));
    }
  }
  function handleChangeMultiAmusementService(value, selectItem) {
    setValue2("amusementList", value);
    let id = [];
    if (!_.isEmpty(getValues2("amusementList"))) {
      getValues2("amusementList").map((item) => id.push(item.value));
    }
  }

  function createUrlAddress() {
    const englishName = getValues2("nameEn");
    const urlName = englishName
      .replace(/[,!?'@]/g, "")
      .replace(/\s+/g, "-")
      .toLowerCase();
    setValue2("urlName", urlName);
  }
  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              {id && id !== "0" ? "ویرایش مجتمع" : " ایجاد مجتمع جدید"}
            </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              {id && id !== "0"
                ? "برای ویرایش مجتمع  فرم زیر را اصلاح نمایید"
                : "برای افزودن مجتمع جدید، فرم زیر را تکمیل نمایید"}
            </span>
          </h3>
        </div>
        {/*Start body */}
        <form key={2} id="form2" onSubmit={handleSubmit2(onSubmit2)}>
          <div className="card-body pt-3 pb-0 border-top">
            <div>
              <h6>مشخصات مجتمع</h6>
              <Row>
                <Col lg="6" xs="12">
                  {" "}
                  <Controller
                    name="name"
                    control={control2}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام مجتمع"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                  {errors2.name && <small className="text-danger">لطفا نام مجتمع را وارد نمایید !</small>}
                </Col>
                <Col lg="6" xs="12">
                  {" "}
                  <Controller
                    name="nameEn"
                    control={control2}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <Row className="align-items-center">
                        <Col xs className="pr-0">
                          <TextField
                            label="نام انگلیسی"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            value={value || ""}
                            onInput={onChange}
                          />
                        </Col>
                        <Col xs="auto" className="pl-1">
                          <Button
                            variant="primary"
                            className="mt-2"
                            style={{ height: "39px" }}
                            onClick={createUrlAddress}
                          >
                            ایجاد آدرس
                          </Button>
                        </Col>
                      </Row>
                    )}
                  />
                  {errors2.nameEn && <small className="text-danger">لطفا نام انگلیسی را وارد نمایید !</small>}
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  {" "}
                  <Controller
                    name="urlName"
                    control={control2}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="urlName"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                  {errors2.urlName && <small className="text-danger">لطفا urlName را وارد نمایید !</small>}
                </Col>
                <Col lg="6">
                  {" "}
                  <Controller
                    name="pageTitle"
                    control={control2}
                    rules={{}}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="عنوان صفحه"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  {" "}
                  <Controller
                    name="imageUrl"
                    control={control2}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="عکس شاخص"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                  {errors2.imageUrl && <small className="text-danger"> لطفا عکس شاخص را وارد نمایید !</small>}
                </Col>
                <Col lg="6">
                  {" "}
                  <Controller
                    name="metaKeywords"
                    control={control2}
                    rules={{ required: false }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="metaKeywords"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  {" "}
                  <Controller
                    name="metaDescription"
                    control={control2}
                    rules={{ required: false }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="metaDescription"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />{" "}
                </Col>
                <Col lg="6" xs="12">
                  <Controller
                    name="cityList"
                    control={control2}
                    rules={{}}
                    render={({ field }) => (
                      <SelectComponent
                        className="w-20 mt-5"
                        placeholder="شهر"
                        options={allCityList?.map((item) => ({
                          value: item.id,
                          label: item.id + "-" + item.name,
                        }))}
                        field={field}
                        onChange={handleChangeMultiCity}
                        isMulti
                      />
                    )}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <Controller
                    name="amusementList"
                    control={control2}
                    render={({ field }) => (
                      <SelectComponent
                        className="mt-5"
                        placeholder="تفریحات"
                        options={allAmusementServiceList?.map((item) => ({
                          value: item.id,
                          label: item.id + "-" + item.name,
                        }))}
                        field={field}
                        onChange={handleChangeMultiAmusementService}
                        isMulti
                      />
                    )}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs="12" lg="6" className="mt-5">
                  <Controller
                    name="lat"
                    control={control2}
                    rules={{
                      validate: (value) => tools.locationValidation(value, getValues2("lon")).latValidation
                    }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="Lat"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={(event) => {
                          const parts = event.target?.value.replace(/[^0-9\u06F0-\u06F9.]/g, "").replace(/٫/g, ".").split(".");
                          if (event.target?.value && (event.target?.value.length > 20 || numberWithDotRegex.test(event.target?.value) || parts.length > 2)) {
                            event.target.value = getValues2("lat")
                            return
                          }
                          onChange(event)
                        }}
                      />
                    )}
                  />
                  <small className="text-danger">{errors2.lat?.message}</small>
                </Col>

                <Col xs="12" lg="6" className="mt-5">
                  <Controller
                    name="lon"
                    control={control2}
                    rules={{
                      validate: (value) => tools.locationValidation(getValues2("lat"), value).lonValidation
                    }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="Lon"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={(event) => {
                          const parts = event.target?.value.replace(/[^0-9\u06F0-\u06F9.]/g, "").replace(/٫/g, ".").split(".");
                          if (event.target?.value && (event.target?.value.length > 20 || numberWithDotRegex.test(event.target?.value) || parts.length > 2)) {
                            event.target.value = getValues2("lon")
                            return
                          }
                          onChange(event)
                        }}
                      />
                    )}
                  />
                  <small className="text-danger">{errors2.lon?.message}</small>
                </Col>
                <Col xs="12" sm="6" className="">
                  <Controller
                    name="address"
                    control={control2}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="آدرس"
                        type="text"
                        rows={2}
                        multiline
                        variant="outlined"
                        margin="normal"
                        className=""
                        value={value || ""}
                        onInput={onChange}
                        sx={{
                          ".css-1b76txz-MuiInputBase-root-MuiOutlinedInput-root": {
                            padding: "8.5px 14px 8.5px 0px !important",
                          }
                        }}
                      />
                    )}
                  />
                </Col>
              </Row>
            </div>
            <hr />
            <Row>
              <Col xs="12">
                {" "}
                <h6 className="my-5"> خلاصه توضیحات</h6>
                <Controller
                  name="descriptionSummary"
                  control={control2}
                  render={({ field: { onChange, value } }) => (
                    <TextEditor
                      data={value || ""}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        onChange(data);
                      }}
                    />
                  )}
                />
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                {" "}
                <h6 className="my-5"> توضیحات</h6>
                <Controller
                  name="description"
                  control={control2}
                  render={({ field: { onChange, value } }) => (
                    <TextEditor
                      data={value || ""}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        onChange(data);
                      }}
                    />
                  )}
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs="12" sm="7" lg="6" className="px-0">
                <div>
                  <FormControlLabel
                    control={
                      <Controller
                        control={control2}
                        name={"status"}
                        render={({
                          field: { onChange, onBlur, value, name, ref },
                          fieldState: { invalid, isTouched, isDirty, error },
                        }) => (
                          <Checkbox
                            color="primary"
                            onBlur={onBlur}
                            onChange={onChange}
                            checked={value || false}
                            inputRef={ref}
                          />
                        )}
                      />
                    }
                    label="فعال"
                  />
                </div>
                <div>
                  <FormControlLabel
                    control={
                      <Controller
                        control={control2}
                        name={"showInHomePage"}
                        render={({
                          field: { onChange, onBlur, value, name, ref },
                          fieldState: { invalid, isTouched, isDirty, error },
                        }) => (
                          <Checkbox
                            color="primary"
                            onBlur={onBlur}
                            onChange={onChange}
                            checked={value || false}
                            inputRef={ref}
                          />
                        )}
                      />
                    }
                    label="نمایش در صفحه اصلی"
                  />
                </div>
                <div>
                  <FormControlLabel
                    control={
                      <Controller
                        control={control2}
                        name={"showInAmusementGroupPage"}
                        render={({
                          field: { onChange, onBlur, value, name, ref },
                          fieldState: { invalid, isTouched, isDirty, error },
                        }) => (
                          <Checkbox
                            color="primary"
                            onBlur={onBlur}
                            onChange={onChange}
                            checked={value || false}
                            inputRef={ref}
                          />
                        )}
                      />
                    }
                    label="نمایش در صفحه دسته بندی"
                  />
                </div>
              </Col>
            </Row>
          </div>
          <div className="float-right mx-5">
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </Button>
            <Link className="btn btn-danger ml-3" to="/amusementComplex">
              <CloseIcon /> بازگشت
            </Link>
          </div>
        </form>
        <Row>
          <Col>
            <ShowImages amusementComplexId={id} />
          </Col>
        </Row>
      </div>
    </div>
  );
};
export default CreateEditAmusementComplex;
